export default ".rapno-general-comment {\n    margin: 0 10px;\n    border-radius: 7px;\n    border: 2px solid #ed6c23;\n    margin-bottom: 20px;\n  }\n";